import { Backdrop, CircularProgress } from "@mui/material";

interface LoadingComponentProps {
  loading: boolean;
}

const LoadingComponent = ({ loading }: LoadingComponentProps) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 9999 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingComponent;
